import React from 'react';
import TeamStats from '../components/team/TeamStats';
import LevelBreakdown from '../components/team/LevelBreakdown';
import ReferralLinkCard from '../components/team/ReferralLinkCard';
import UnlockCard from '../components/team/UnlockCard';
import { useContractState } from '../context/ContractContext';
import EmptyState from '../components/common/EmptyState';

export default function Team() {
  const { userId } = useContractState();
  return (
    <div className="page">
      <div className="page-title grad-text">Team</div>
      <p className="page-subtitle">Build your network — earn one-time level income up to 15 levels deep.</p>

      {userId === 0 ? (
        <EmptyState icon="👥" title="Register to unlock your team" msg="Your referral link and level breakdown appear after registration." />
      ) : (
        <>
          <ReferralLinkCard />
          <UnlockCard />
          <TeamStats />
          <div className="section-header"><h2>Level Breakdown</h2></div>
          <LevelBreakdown />
        </>
      )}
    </div>
  );
}
